import { formatPhoneNumber } from '../../../../../utils/formatPhoneNumber';

const additionalInfo = (data, t) => {
  const {
    address,
    phone_number,
    cell_phone_number,
    email,
    is_animals,
    liked_animals_types,
    is_smoker,
    is_newsletters,
    moving_with_animal,
    animals_experiences,
    secondary_profile
  } = data;

  return [
    {
      label: 'pensioners.form.address.street',
      span: 1,
      content:
        address?.number || address?.street
          ? `${address?.number || ''} ${address?.street || ''}`
          : '-'
    },
    {
      label: 'pensioners.form.address.city_country',
      span: 1,
      content: `${address?.postal_code || '-'} ${address?.city || '-'}`
    },
    {
      label: 'pensioners.form.address.country',
      span: 1,
      content: address?.country || '-'
    },
    {
      label: 'pensioners.form.phone_number.number',
      span: 1,
      content: phone_number?.number ? `${formatPhoneNumber(phone_number)}` : '-'
    },
    {
      label: 'pensioners.form.cell_phone_number.number_1',
      span: 1,
      content: cell_phone_number?.number
        ? `${formatPhoneNumber(cell_phone_number)}`
        : '-'
    },
    {
      label: 'pensioners.form.cell_phone_number.number_2',
      span: 1,
      content: secondary_profile?.cell_phone_number?.number
        ? `${formatPhoneNumber(secondary_profile?.cell_phone_number)}`
        : '-'
    },
    {
      label: 'pensioners.form.email',
      span: 1,
      content: email || '-'
    },
    {
      label: 'pensioners.form.is_animals',
      span: 1,
      content: is_animals ? t(`pensioners.form.yes`) : t(`pensioners.form.no`)
    },
    ...(is_animals
      ? [
          {
            label: 'pensioners.form.liked_animals_types',
            span: 1,
            content: liked_animals_types?.length
              ? liked_animals_types
                  .map((type) => t(`animals.tags.${type}`))
                  .join(', ')
              : '-'
          }
        ]
      : []),
    {
      label: 'pensioners.form.is_smoker',
      span: 1,
      content: is_smoker ? t(`pensioners.form.yes`) : t(`pensioners.form.no`)
    },
    {
      label: 'pensioners.form.is_newsletters',
      span: 1,
      content: is_newsletters
        ? t(`pensioners.form.yes`)
        : t(`pensioners.form.no`)
    },
    {
      label: 'pensioners.form.moving_with_animal',
      span: 1,
      content: moving_with_animal
        ? t(`pensioners.form.yes`)
        : t(`pensioners.form.no`)
    },
    ...(animals_experiences?.length
      ? [
          {
            label: 'pensioners.form.animals_experiences',
            span: 1,
            content: Array.isArray(animals_experiences)
              ? animals_experiences.join(', ')
              : animals_experiences
          }
        ]
      : [])
  ];
};

export { additionalInfo };
